export default "https://cdn-static.gokick.com/assets/6909edbc169b94fbe838446b12805066cb856688/images/gokick-home-thumb.d0805bfbe5c122bc4415664ec8f6d56b.png";